export const DragableItemTypes = 
{
    StudentCard : 'StudentCard',
    StudentGroupCard : 'StudentGroupCard',
}